import React, { createContext, useContext, ReactNode } from 'react';
import { useCart, UseCartReturn } from '../hooks/useCart';

interface CartProviderProps {
  children: ReactNode;
}

const CartContext = createContext<UseCartReturn | undefined>(undefined);

export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
  const cartData = useCart();

  return (
    <CartContext.Provider value={cartData}>
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCartContext must be used within a CartProvider');
  }
  return context;
};

// Exportando useCart para compatibilidade
export { useCart };

export default CartContext;